import { app } from '../../../app';
import { Controller } from './corporate-settings.controller';

app.component('corporateSettings', {
    bindings:{
        settings:'<',
    },
    controller: Controller,
    templateUrl: require('./corporate-settings.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/corporate-settings/corporate-settings.component.js